import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className: `
    pointer-events-none
    z-1
    col-span-1
    row-span-1
    h-full
    w-full
    bg-white
    blur-sm
    transition-opacity
  `
});
